<template>
    <!-- 滑动返回上一页 -->
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="orderConfirmation">
            <!-- 顶部导航，标题，返回按钮，返回按钮名称 -->
            <van-nav-bar
                title="扫码核对"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <div class="content">
                <div class="card">
                    <h3>发货单号:{{ deliveryData.delivery_receipt_number }}</h3>
                    <ul>
                        <li class="cardCell">
                            <p>
                                <img src="@/assets/images/icons/icon_gy_9.png" alt="">
                                <span>车牌号:{{ deliveryData.plate_number }}</span>
                            </p>
                            <p>
                                <img src="@/assets/images/icons/icon_18.png" alt="">
                                <span>车号:{{ deliveryData.car_code }}</span>
                            </p>
                        </li>
                        <li class="cardCell">
                            <p>
                                <img src="@/assets/images/icons/icon_30.png" alt="">
                                <span>发货方量:{{ deliveryData.deliver_volume }}m³ </span>
                            </p>
                            <p>
                                <img src="@/assets/images/icons/icon_30.png" alt="">
                                <span>签收方量:{{ deliveryData.sign_volume }}m³ </span>
                            </p>
                        </li>
                        <li class="cardCell borderNone">
                            <p>
                                <img src="@/assets/images/icons/icon_3.png" alt="">
                                <span>驾驶员:{{ deliveryData.sjxm }}</span>
                            </p>
                        </li>
                    </ul>
                    <div class="cardChange">
                        <p class="borderDashed"></p>
                        <h3 class="changeTitle">
                            调整后签收方量
                        </h3>
                        <div class="stepperSection">
                            <van-stepper
                                v-model="adjusted_sign_volume"
                                min="0"
                                input-width="50.667vw"
                                button-size="10.667vw"
                            >
                            </van-stepper>
                        </div>
                        <div class="submitSection">
                            <p class="abnormal" @click="otherAnomalies">
                                其他异常
                            </p>
                            <p class="submit" @click="handleSubmit">
                                核对完成
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-touch>
</template>

<script>
import { eventBus } from '@/common/eventBus.ts';
export default {
    // 缺失发货单
    name: 'scan-code-check',
    components: {},
    props: {},
    data() {
        return {
            // 单号数据
            deliveryData: {},
            // 步进器
            adjusted_sign_volume: 0,
        };
    },
    computed: {},
    watch: {},
    created() {
        // 转发原生回调函数
        window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
        this.deliveryData = this.$route.query.deliveryData;
        this.adjusted_sign_volume = this.deliveryData.adjusted_sign_volume || 0;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/invoiceCheck' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/invoiceCheck' });
        },
        // 拉取发货单数据
        getOrderData() {
            // delivery_receipt_number 发货单号
            const params = '';
            this.$axios
                .get('/interfaceApi/sale/accounts/get_scan_day_type' + params)
                .then(res => {
                    this.deliveryData = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 提交审核
        handleSubmit() {
            this.$axios.put('/interfaceApi/sale/accounts/delivery_receipt_check', {
                delivery_receipt_number: this.deliveryData.delivery_receipt_number,
                adjusted_sign_volume: this.adjusted_sign_volume,
            }).then(() => {
                this.$toast.success('核对成功');
                setTimeout(() => {
                    this.$router.replace('/invoiceCheck');
                    eventBus.$emit('OpenScanCode');
                }, 500);
            }).catch(error => {
                this.$dialog({ message: error.ErrorCode.Message });
            });
        },
        // 其他异常
        otherAnomalies() {
            this.$axios.put(`/interfaceApi/sale/accounts/delivery_receipt_exception/${this.deliveryData.delivery_receipt_number}`)
                .then(() => {
                    this.$toast.success('设置成功');
                    setTimeout(() => {
                        this.$router.replace('/invoiceCheck');
                        eventBus.$emit('OpenScanCode');
                    }, 500);
                }).catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus" scoped>
.orderConfirmation
    height 100%
    .content
        position relative
        height: calc(100% - 45rpx)
        background rgba(0,0,0,0.5)
        .card
            position absolute
            top 50%
            left 50%
            width 300rpx
            margin auto
            border-radius 5rpx
            overflow hidden
            transform translate(-50%,-50%)
            filter: drop-shadow(3rpx 3rpx 3rpx rgba(0,0,0,.3));
            h3
                height 42rpx
                padding-left 18rpx
                font-size: 16rpx
                color: #061F3E
                line-height 42rpx
                background #F5F8FE
            .cardCell
                display flex
                padding-left 15rpx
                height 44rpx
                background #fff
                border-bottom 1px solid #F0F0F0
                box-sizing border-box
                p
                    display flex
                    align-items center
                    width 50%
                    vertical-align middles
                    img,span
                        display inline-block
                        height 16rpx
                        line-height 16rpx
                    img
                        width 16rpx
                        margin-right 5rpx
                    span
                        font-size 14rpx
                        color #666
                        white-space nowrap
            .borderNone
                border none
                background:
                radial-gradient(circle at left bottom, transparent 10rpx, #fff 0) top left /50% 44rpx no-repeat,
                radial-gradient(circle at right bottom, transparent 10rpx, #fff 0) top right /50% 44rpx no-repeat
            .cardChange
                .borderDashed
                    width 280rpx
                    height 1px
                    margin 0 auto
                    border-bottom 1px dashed #F0F0F0
                    box-sizing border-box
                .changeTitle
                    height: 45rpx;
                    padding 15rpx 0 0
                    font-size: 16rpx;
                    color: #061F3E;
                    line-height 30rpx
                    text-align center
                    background:
                    radial-gradient(circle at left top, transparent 10rpx, #fff 0) bottom left /50% 45rpx no-repeat,
                    radial-gradient(circle at right top, transparent 10rpx, #fff 0) bottom right /50% 45rpx no-repeat;
                .stepperSection
                    display flex
                    justify-content center
                    align-items center
                    padding-top 10rpx
                    background #fff
                .stepperTips
                    display flex
                    align-items center
                    justify-content space-between
                    height 54rpx
                    padding 0 15rpx
                    background #fff
                    border-bottom 1px solid #f0f0f0
                    p
                        width: 80rpx
                        height: 24rpx
                        font-size: 16rpx
                        color: #FA8436
                        text-align center
                        background: #FFF8F3
                        border: 1px solid #FFECDE
                .submitSection
                    display flex
                    align-items center
                    justify-content center
                    height 70rpx
                    background #fff
                    p
                        width 120rpx
                        height 40rpx
                        font-size 16rpx
                        margin 0 10rpx
                        color #fff
                        line-height 40rpx
                        text-align center
                        border-radius 20rpx
                        &.submit
                            background #5588F1
                        &.abnormal
                            background #D6000F
</style>
<style lang="stylus">
.orderConfirmation
    .van-stepper
        margin 0 auto
        .van-stepper__minus,.van-stepper__plus
            background #3495FB
            color #fff
            font-weight 700
        .van-stepper__input
            margin 0
            font-size: 16px
            color: #3495FB
            border-top 1px solid #D7D7D7
            border-bottom 1px solid #D7D7D7
</style>
